import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SolicitudCamService } from '../../datosbasicos/solicitud-cam.service';
import { catchError, of, tap } from 'rxjs';
import { EnviarSolicitudViewModel, TwSolicitudCamViewModelExtended } from '../../../types/solicitudcam-datosbasicos.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { CodigoConfeccionItemViewModel } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.types';
import { CodigoConfeccionService } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.service';
import { PeriodoCamService } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.service';
import { PeriodoCamViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
import { CampaniasGlobalService } from '../../../services/global-campanias.service';
import { TCampaniaEspecificaViewModel } from 'src/app/components/_mantenimiento/campanias/campaniasespecificas/campaniaespecifica.types';
import { DocumentoSolicitudCamViewModel } from '../../documentacion/solicitud-documentacion.types';
import { DocumentosSolicitudCamService } from '../../documentacion/solicitud-documentacion.service';
import { EnumIdsTcTipoSolicitudCam, EnumDescripcionTcTipoSolicitudCamSingular, EnumIdsTcEstadoSolicitudCam } from '../../../types/enum';
import { CASelectedViewModel } from '../../../buscadores/solicitudes/buscador-solicitud-cam.types';
import { ForeignKeyValidator } from 'src/app/components/core/_infrastructure/classes/foreignKeyValidator';

@Component({
    selector: 'app-solicitud-cam-envio-wrapper',
    templateUrl: './solicitud-cam-envio-wrapper.component.html',
    styleUrls: ['./solicitud-cam-envio-wrapper.component.scss'],
})
export class SolicitudCamEnvioWrapperComponent extends ComponentBase implements OnInit {
    solicitudCam: TwSolicitudCamViewModelExtended;
    campaniaEspecifica: TCampaniaEspecificaViewModel;
    documentosSolicitudCam: DocumentoSolicitudCamViewModel[];
    almacenes: CodigoConfeccionItemViewModel[];
    cicloCorto = false;
    periodoCam: PeriodoCamViewModel;
    documentosObligatoriosSinAdjuntar: number | null = null;

    visibilitySpinnerEnvio = false;
    envioNotAllowed = true;
    showErrors = false;
    formGroup: FormGroup;

    public erroresRecintosPIAIds: number[];

    private listUrl = '/campanias/solicitudes';

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitudCam: string | null = params.get('id');
        if (idSolicitudCam) {
            this.getSolicitudCam(parseInt(idSolicitudCam));
        }
    });

    private successMessage = 'Envío realizado satisfactoriamente';

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private solicitudCamService: SolicitudCamService,
        private campaniaGlobalService: CampaniasGlobalService,
        private documentosSolicitudCamService: DocumentosSolicitudCamService,
        private almacenesService: CodigoConfeccionService,
        private periodoCamService: PeriodoCamService,
        private navMenuService: NavMenuService,
        private router: Router,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        protected notificacionService: NotificationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            Id: [null], // Not visible but needed
            IdCampania: [{ value: null, disabled: true }],
            IdPeriodoCam: [{ value: null, disabled: true }],
            IdCA: [{ value: null, disabled: true }],
            IdEntidadAuditora: [{ value: null, disabled: true }],
            IdTipoSolicitudCam: [{ value: null, disabled: true }], // Tipo de recinto
            Campania: [{ value: null, disabled: true }],
            Periodo: [{ value: null, disabled: true }],
            DescripcionComunidad: [{ value: null, disabled: true }],
            EntidadAuditora: [{ value: null, disabled: true }],
            TipoSolicitudCam: [{ value: null, disabled: true }], // Descripción del Tipo de recinto
            IdEstadoSolicitudCam: [null], // Not visible but needed
            EstadoSolicitudCam: [{ value: null, disabled: true }], // readonly
            FechaCreacion: [null], // Not visible but needed
            FechaSolicitud: [{ value: null, disabled: true }], // readonly
            Codigo: [{ value: null, disabled: true }], // readonly
            IdUsuario: [false], // Not visible but needed
            OperadorRazonSocial: [{ value: null, disabled: true }], // readonly
            OperadorNif: [{ value: null, disabled: true }], // readonly
            OperadorTelefono: [{ value: null, disabled: true }], // readonly
            IdAlmacenExportacionCicloCorto: [{ value: null, disabled: true }], // Estará habilitado con ciclo corto
            AlmacenExportacionCicloCorto: [{ value: null, disabled: true }], // readonly
        });
        this.form = this.formGroup;
    }

    /**
     * Este método obtiene los datos de la solicitud indicada por parámetro.
     * Una vez obtenida, establece el valor para la propiedad readonly a partir de la información del usuario y los permisos de edición.
     * Después invoca al servicio de obtención de recintos de la solicitud y al core para saber si la CA está configurada para el periodo (puede ocurrir que llegados a ésta pantalla no esté configurada)
     * @param idSolicitudCam number
     */
    private getSolicitudCam(idSolicitudCam: number): void {
        this.solicitudCamService
            .getSolicitudCamExtended(idSolicitudCam)
            .pipe(
                tap((v: TwSolicitudCamViewModelExtended) => {
                    this.solicitudCam = v;
                    this.navMenuService.updateMenuServiceForSolicitudCam(v.Id!, v.IdEstadoSolicitudCam!, v.IdTipoSolicitudCam);
                    this.envioNotAllowed = this.isEnvioNotAllowed();
                    this.loadCampaniaData(this.solicitudCam.IdCampania!);
                    this.getPeriodoCam(this.solicitudCam.IdPeriodoCam);
                    this.checkConfiguracionPeriodo();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Cargamos los datos asociados a la campaña a la que está vinculada la solicitud de campaña.
     * Lo que utilizaremos será la configuración para la documentación.
     * @param idCampania number
     */
    private loadCampaniaData(idCampania: number): void {
        this.campaniaGlobalService
            .getCampaniaById(idCampania)
            .pipe(
                tap((ce: TCampaniaEspecificaViewModel) => {
                    this.campaniaEspecifica = ce;
                    this.loadDocumentosSolicitudCam(this.solicitudCam?.Id || 0);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.formGroup?.disable();
                    return of([]);
                }),
            )
            .subscribe(); // Sin subscribe, no se ejecuta la invocación al servicio
    }

    /**
     * Cargamos la documentación asociada a la solicitud de campaña.
     * @param idSolicitudCam number
     */
    private loadDocumentosSolicitudCam(idSolicitudCam: number): void {
        this.documentosSolicitudCamService
            .getDocumentosSolicitudCam(idSolicitudCam)
            .pipe(
                tap((docsSolicitudCamVM: DocumentoSolicitudCamViewModel[]) => {
                    this.documentosSolicitudCam = docsSolicitudCamVM;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.formGroup?.disable();
                    return of(null);
                }),
            )
            .subscribe(); // Sin subscribe, no se ejecuta la invocación al servicio
    }

    /**
     * Método que invoca a la API para cargar los datos de un periodo a partir de su id.
     * @param id number
     * @return void
     */
    private getPeriodoCam(id: number): void {
        this.periodoCamService
            .getById(id)
            .pipe(
                tap((p: PeriodoCamViewModel) => {
                    this.periodoCam = p;
                    this.cicloCorto = this.esCicloCorto;
                    if (this.almacenObligatorio && this.estadoSolicitudAdmiteEnvio) {
                        this.loadAlmacenes(this.solicitudCam.IdPeriodoCam!, this.periodoCam?.IdCampania);
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Este métod, además de obtener las EAs configuradas para el periodo y CA,
     * también permite revisar que esté configurada la CA para el periodo.
     */
    private checkConfiguracionPeriodo(): void {
        const payload: CASelectedViewModel = new CASelectedViewModel();
        payload.idCA = this.solicitudCam.IdCa;
        payload.idPeriodo = this.solicitudCam.IdPeriodoCam;

        this.campaniaGlobalService
            .getEAsByCA(payload)
            .pipe(
                tap(() => {
                    // NO-OP
                }),
                catchError(error => {
                    this.envioNotAllowed = true;
                    this.catchServerError(error);
                    this.formGroup.disable();
                    if (error?.error?.length > 0) {
                        this.addErrorMessage(error.error[0]?.message);
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Se obtienen la lista de almacenes que cumpla:
     * - Se buscan almacenes de solicitudes aceptadas en el periodo.
     * - Estos almacenes tendrán que:
     *      - estar activos
     *      - no estar desautorizados en la misma campaña
     *      - no estar en una UI dada de baja en el periodo
     * - A partir de éstas solicitudes se obtienen los almacenes y se devuelven.
     * - Este mismo método se aplica en el componente InspeccionUiAforoCorteWrapperEditComponent
     */
    private loadAlmacenes(idPeriodo: number, idCampania: number): void {
        this.almacenesService
            .getAlmacenesAceptadosByIdPeriodo(idPeriodo, idCampania)
            .pipe(
                tap((almacenes: CodigoConfeccionItemViewModel[]) => {
                    this.almacenes = almacenes;
                    this.manageCicloCortoValidation();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private manageCicloCortoValidation(): void {
        if (this.estadoSolicitudAdmiteEnvio) {
            if (!this.envioNotAllowed) {
                this.formGroup.controls['IdAlmacenExportacionCicloCorto'].enable();
            }
            // Puede darse el caso que sea ciclo corto y no haya almacenes autorizados para exportar.
            if (this.almacenObligatorio) {
                this.formGroup.controls['IdAlmacenExportacionCicloCorto'].addValidators(Validators.required);
                this.formGroup.controls['IdAlmacenExportacionCicloCorto'].addValidators(ForeignKeyValidator.cannotBeNullOrZero);
            } else {
                this.formGroup.controls['IdAlmacenExportacionCicloCorto'].removeValidators(Validators.required);
                this.formGroup.controls['IdAlmacenExportacionCicloCorto'].removeValidators(ForeignKeyValidator.cannotBeNullOrZero);
            }
            this.formGroup.controls['IdAlmacenExportacionCicloCorto'].updateValueAndValidity();
        }
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    onClickEnvio(): void {
        const model = new EnviarSolicitudViewModel();
        model.IdAlmacenExportacionCicloCorto = this.form.value.IdAlmacenExportacionCicloCorto;
        model.IdSolicitudCam = this.solicitudCam.Id!;
        model.IdTipoSolicitudCam = this.solicitudCam.IdTipoSolicitudCam;
        model.IdUsuario = 0;

        this.enviar(model);
    }

    private enviar(model: EnviarSolicitudViewModel): void {
        this.erroresRecintosPIAIds = [];
        this.visibilitySpinnerEnvio = true;
        this.solicitudCamService
            .enviar(model)
            .pipe(
                tap(() => {
                    this.envioNotAllowed = true;
                    this.visibilitySpinnerEnvio = false;
                    this.addSuccessMessage(this.successMessage);
                    this.getSolicitudCam(model.IdSolicitudCam); // Volvemos a cargar los datos de la solicitud de cam.
                }),
                catchError(response => {
                    this.catchServerError(response);
                    this.visibilitySpinnerEnvio = false;

                    if (response?.error instanceof Array) {
                        response?.error?.forEach((error: { key: string; field: string; message: string }) => {
                            switch (error?.field) {
                                case 'IdCultivo':
                                case 'IdAlmacen':
                                case 'IdEmpresaDeshidratadora':
                                    this.addWarningMessage(error.message);
                                    this.erroresRecintosPIAIds.push(parseInt(error.key));
                                    break;
                                default:
                                    this.addErrorMessage(error.message);
                                    break;
                            }
                        });
                    }
                    if (this.erroresRecintosPIAIds.length > 0) {
                        this.showErrors = true;
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    getDocumentosObligatoriosSinAdjuntar(): number {
        if (this.campaniaEspecifica?.Documentacion === null || this.documentosSolicitudCam === null) return 0;
        if (this.documentosObligatoriosSinAdjuntar === null) {
            this.documentosObligatoriosSinAdjuntar = this.documentosSolicitudCamService.getDocumentosObligatoriosSinAdjuntar(
                this.campaniaEspecifica?.Documentacion,
                this.documentosSolicitudCam,
            );
        }
        return this.documentosObligatoriosSinAdjuntar;
    }

    private get userIsOwner(): boolean {
        return this.isOperadorCam && this.solicitudCam && this.loggedInUser?.Id === this.solicitudCam?.IdUsuario;
    }

    /**
     * Este componente no permitirá el envío de la solicitud cuando el usuario actual no sea Operador de Campaña.
     * Si el usuario no es el propietario, también se bloquea.
     * Además el estado de la solicitud tendrá que ser uno de los permitidos para el envío.
     * @returns boolean Si devuelve true es que el envío no está permitido. False si está permitido
     */
    private isEnvioNotAllowed(): boolean {
        if (this.solicitudCam?.PeriodoPresentacionVigente === false) {
            return true; // Envío no permitido
        }
        const hasAccessToEnvio = this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.SEND_SOL_CAM, this.solicitudCam?.IdEstadoSolicitudCam).Editable || false;

        if (!hasAccessToEnvio) {
            return true; // Si no tiene acceso, envío no permitido
        }

        if (this.isOperadorCam) {
            return false; // Envío permitido
        }

        return !this.userIsOwner; // Envío permitido si es propietario
    }

    get esPeriodoVigente(): boolean {
        return this.solicitudCam?.PeriodoVigente;
    }

    get esCicloCorto(): boolean {
        switch (this.solicitudCam?.IdTipoSolicitudCam) {
            case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                return this.periodoCam?.CicloCortoInspConfeccion || false;
            case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                return this.periodoCam?.CicloCortoInspEmpresasDeshidratacion || false;
            case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                return this.periodoCam?.CicloCortoInspParcela || false;
            case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                return this.periodoCam?.CicloCortoInspInvernadero || false;
        }
        return false;
    }

    get almacenObligatorio(): boolean {
        return this.cicloCorto && this.esTipoRecintosPI;
    }

    private get estadoSolicitudAdmiteEnvio(): boolean {
        if (!this.solicitudCam) {
            return false;
        }
        return (
            this.solicitudCam?.IdEstadoSolicitudCam === EnumIdsTcEstadoSolicitudCam.ID_DEVUELTA ||
            this.solicitudCam?.IdEstadoSolicitudCam === EnumIdsTcEstadoSolicitudCam.ID_BORRADOR
        );
    }

    get title(): string {
        if (!this.solicitudCam) return '';

        switch (this.solicitudCam?.IdTipoSolicitudCam) {
            case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                return 'un ' + EnumDescripcionTcTipoSolicitudCamSingular.CONFECCION;
            case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                return 'una ' + EnumDescripcionTcTipoSolicitudCamSingular.EMPRESA_DESHIDRATACION;
            case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                return 'una ' + EnumDescripcionTcTipoSolicitudCamSingular.PARCELA;
            case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                return 'un ' + EnumDescripcionTcTipoSolicitudCamSingular.INVERNADERO;
            default:
                return 'un ' + EnumDescripcionTcTipoSolicitudCamSingular.RECINTO;
        }
    }

    private get esTipoRecintosPI(): boolean {
        return (
            this.solicitudCam?.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_INVERNADERO ||
            this.solicitudCam?.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_PARCELA
        );
    }

    get formInvalid(): boolean {
        if (this.almacenes?.length > 0) {
            return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
        }
        return !this.formGroup.valid;
    }
}
